import React, { useMemo } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ title, data, labels }) => {
  const chartData = useMemo(() => ({
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: [
          '#10B981',
          '#3B82F6',
          '#8B5CF6',
          '#F59E0B',
          '#EF4444',
          '#64748B',
        ],
        borderColor: '#FFFFFF',
        borderWidth: 2,
      },
    ],
  }), [labels, data]);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 200,
    animation: false,
    transitions: {
      resize: {
        animation: {
          duration: 0
        }
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            family: 'Inter',
            size: 12,
            weight: '500',
          },
          color: '#6B7280',
          padding: 15,
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
      tooltip: {
        backgroundColor: '#0F172A',
        padding: 12,
        cornerRadius: 8,
        titleFont: {
          family: 'Inter',
          size: 13,
          weight: '600',
        },
        bodyFont: {
          family: 'Inter',
          size: 14,
          weight: '500',
        },
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${percentage}%`;
          },
        },
      },
    },
  }), []);

  return (
    <div data-testid="pie-chart" className="bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-200 p-6">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">{title}</h3>
      <div className="relative w-full" style={{ height: '360px', minHeight: '360px', maxHeight: '360px' }}>
        <Pie data={chartData} options={options} />
      </div>
    </div>
  );
};

export default React.memo(PieChart);